import type { EffectCallback } from 'react';
import { useEffect, useRef } from 'react';

/**
 * Runs the provided effect once when the component mounts, subsequent renders
 * will not re-run the effect.
 *
 * The effect may return a cleanup function, which will be called when the
 * component unmounts.
 */
export function useMountEffect(effect: EffectCallback) {
  const effectRef = useRef(effect);
  effectRef.current = effect;
  useEffect(() => effectRef.current?.(), []);
}
